import { Component, computed, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppInfo } from '../../global/environment';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { FirstLetterCapitalisePipe } from '../../shared/pipes/firstLetterCapitilise';
import { ClaimDetailsComponent } from './components/claim-details/claim-details.component';
import { DirectReferralComponent } from './components/direct-referral/direct-referral.component';
import { ElectricalSafetyComponent } from './components/electrical-safety/electrical-safety.component';
import { HistoryComponent } from './components/history/history.component';
import { MmrFaqsComponent } from './components/mmr-faqs/mmr-faqs.component';
import { MmrPageErrorComponent } from './components/mmr-page-error/mmr-page-error.component';
import { MmrTitleBlockComponent } from './components/mmr-title-block/mmr-title-block.component';
import { SmartFixHubComponent } from './components/smart-fix-hub/smart-fix-hub.component';
import { SupportNeedsBannerComponent } from './components/support-needs-banner/support-needs-banner.component';
import { LoadPlanClaimsObject, MmrService } from './services/mmr.service';

@Component({
  selector: 'app-mmr',
  imports: [
    MmrTitleBlockComponent,
    MmrPageErrorComponent,
    ButtonComponent,
    MmrFaqsComponent,
    HistoryComponent,
    ClaimDetailsComponent,
    DirectReferralComponent,
    SmartFixHubComponent,
    FirstLetterCapitalisePipe,
    ElectricalSafetyComponent,
    SupportNeedsBannerComponent,
  ],
  templateUrl: './mmr.component.html',
  styleUrl: './mmr.component.scss',
  host: {
    class: 'max-w-840 full-width p-24 mx-auto',
  },
})
export class MmrComponent implements OnInit {
  planNumber!: string;

  pageDetails!: LoadPlanClaimsObject;

  readonly viewModel = computed(() => {
    const planDetails = this.mmrService.planClaimsDetails.plan;
    const claims = this.mmrService.planClaimsDetails.claims;
    const manufacturerName = planDetails.value()?.manufacturer || '';
    const goodsColour = planDetails.value()?.goodsColour ?? '';
    const pageContent = planDetails.value()?.pageContent;

    return {
      isError: !!planDetails.error(),
      goodsColour: goodsColour,
      repairerName: `${manufacturerName.charAt(0).toUpperCase()}${manufacturerName.slice(1).toLowerCase()}`,
      showFAQs: planDetails.isLoading() || ['W', 'H'].includes(goodsColour),
      viewPlanDetailsUrl: `${AppInfo.Environment.myAccountURL}/my-plans/${this.planNumber}`,
      dashboardLink: `${AppInfo.Environment.myAccountURL}/my-plans`,
      planDetailsLoading: planDetails.isLoading(),
      claimsInformationLoading: claims.isLoading(),
      showHistoryPanel: pageContent?.showHistoryPanel ?? false,
      showRepairPanel: pageContent?.showRepairPanel ?? false,
      showServicePanel: pageContent?.showServicePanel ?? false,
      showElectricalSafety: pageContent?.showElectricalSafety ?? false,
      showDirectReferralPanel: claims.value()?.repair?.panelDisplay === 'DIRECT_REFERRAL_ONLY',
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly mmrService: MmrService
  ) {}

  ngOnInit(): void {
    this.planNumber = this.activatedRoute.snapshot.params['planNumber'];
    this.mmrService.loadPlanClaims(this.planNumber);
    this.pageDetails = this.mmrService.planClaimsDetails;
  }
}
